<template>
  <base-data-table
    server
    v-model:options="dataTableOptions"
    :items="data"
    :loading="dataLoading"
    :items-per-page="itemPerPage"
    v-bind="$attrs"
    :items-length="dataTotal"
  >
    <template v-for="(_, slot) in $slots" #[slot]="slotProps">
      <slot :name="slot" v-bind="slotProps || {}" />
    </template>
  </base-data-table>
</template>

<script>
export default {
  name: 'BaseDataTableRemote',

  inheritAttrs: false,

  props: {
    getData: {
      type: Function,
      default: null,
    },
    rowsPerPage: {
      type: Number,
      default: null,
    },
  },

  data: () => ({
    dataTableOptions: {},
    dataLoading: true,
    data: [],
    dataTotal: 0,
  }),

  computed: {
    itemPerPage() {
      if (this.rowsPerPage) return this.rowsPerPage;

      let perPage = 10;
      if (window.screen.height >= 1200) {
        perPage = 15;
      } else if (this.$vuetify.display.xs) {
        perPage = 5;
      }
      return perPage;
    },
  },

  watch: {
    dataTableOptions: {
      handler() {
        this.loadData();
      },
      deep: true,
    },
  },

  methods: {
    normalizeSort(options) {
      const { sortBy } = options;
      if (!Array.isArray(sortBy) || !sortBy.length) {
        return { sortBy: [], sortDesc: [] };
      }

      if (typeof sortBy[0] === 'object' && sortBy[0] !== null) {
        return {
          sortBy: sortBy.map((entry) => entry.key),
          sortDesc: sortBy.map((entry) => entry.order === 'desc'),
        };
      }

      return {
        sortBy,
        sortDesc: options.sortDesc || [],
      };
    },

    /**
     * Resolve total rows from API pagination meta (Laravel-style).
     * Prefer meta.total; fall back to other common fields if total is missing.
     */
    resolveDataTotal(response, pageItems) {
      const body = response && response.data;
      if (!body) {
        return pageItems.length;
      }
      const meta = body.meta || {};
      const candidates = [
        meta.total,
        meta.total_count,
        body.total,
        meta.to,
      ];
      for (let i = 0; i < candidates.length; i += 1) {
        const n = Number(candidates[i]);
        if (Number.isFinite(n) && n >= 0) {
          return n;
        }
      }
      return pageItems.length;
    },

    loadData() {
      const { page, itemsPerPage } = this.dataTableOptions;
      const { sortBy, sortDesc } = this.normalizeSort(this.dataTableOptions);

      if (page && itemsPerPage) {
        this.dataLoading = true;
        this.getData(page, itemsPerPage, sortBy, sortDesc).then((response) => {
          this.data = (response.data && response.data.data) || [];
          this.dataTotal = this.resolveDataTotal(response, this.data);
          if ((page === 1) && !this.dataTotal) {
            this.dataTotal = this.data.length;
          }
          this.$emit('data-total', this.dataTotal);
          this.dataLoading = false;
        })
          .catch((error) => {
            this.dataLoading = false;
            if (error.response?.data?.errors) {
              this.$store.dispatch('pushErrors', error.response.data.errors);
            }
          });
      }
    },
  },
};
</script>
